var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRupeesimg(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4375 15L0.833333 9.16667V7.5H3.75C4.48611 7.5 5.12167 7.26028 5.65667 6.78083C6.19111 6.30194 6.51389 5.70833 6.625 5H0V3.33333H6.375C6.13889 2.84722 5.78833 2.44778 5.32333 2.135C4.85778 1.82278 4.33333 1.66667 3.75 1.66667H0V0H10V1.66667H7.29167C7.48611 1.90278 7.65972 2.15972 7.8125 2.4375C7.96528 2.71528 8.08333 3.01389 8.16667 3.33333H10V5H8.3125C8.20139 6.18056 7.71528 7.17 6.85417 7.96833C5.99306 8.76722 4.95833 9.16667 3.75 9.16667H3.14583L8.75 15H6.4375Z",
    fill: "#333333"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeesimg);
export default __webpack_public_path__ + "static/media/rupeesimg.8cdf7deefb3b4f06350baa983f6cdc4e.svg";
export { ForwardRef as ReactComponent };